import AnimCounter from '../../components/AnimCounter';

const STATS = [
  { end: 88, suffix: '.5%', prefix: '',      label: 'UAE are expats'  },
  { end: 0,  suffix: '',    prefix: 'AED ',  label: 'Hidden Fees'     },
  { end: 30, suffix: 's',   prefix: '',      label: 'Create a game'   },
  { end: 100,suffix: '%',   prefix: '',      label: 'Free forever'    },
];

export default function StatsBar() {
  return (
    <section style={{
      background: 'var(--navy2)',
      borderTop:    '1px solid rgba(232,96,74,0.1)',
      borderBottom: '1px solid rgba(232,96,74,0.1)',
      padding: '3.5rem clamp(1rem,4vw,3rem)',
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '2rem',
      }}>
        {STATS.map((s, i) => (
          <div key={i} className="vis" style={{ textAlign: 'center' }}>
            <div style={{
              fontFamily: 'var(--font-d)', fontSize: 56,
              fontWeight: 900, color: 'var(--coral)', lineHeight: 1,
            }}>
              <AnimCounter end={s.end} suffix={s.suffix} prefix={s.prefix} />
            </div>
            <div style={{
              fontFamily: 'var(--font-m)', fontSize: 11, color: 'var(--muted)',
              letterSpacing: 2, marginTop: 6, textTransform: 'uppercase',
            }}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
